import './Trasparenza.css';
import './TrasparenzaPage.css';
import TrasparenzaContent from './TrasparenzaContent';

function TrasparenzaPage() {
    return (
        <div className='trasparenza-page-container'>
            <TrasparenzaContent />
        </div>
    );
}

export default TrasparenzaPage;
